import React, {ChangeEvent, FunctionComponent, KeyboardEvent, StrictMode, useState} from 'react'
import {SearchIcon} from "@App/Components/common/Icons"
import {XIcon} from "@heroicons/react/solid";
import {useDelayedInput} from "@App/hooks/useDelayedInput";
import {changeNameFilter} from "@App/state/action-creators";
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";

type GarageNameSearchProps = {
    className?: string,
}

type GarageNameSearchState = {
    delayedSearch?: string,
};

export const GarageNameFilter: FunctionComponent<GarageNameSearchProps> = (props: GarageNameSearchProps = {className: ''}, state: GarageNameSearchState) => {

    const search = useSelector((state: State) => state.filters.search)

    const [delayedSearch, setDelayedSearch] = useState(search)

    const dispatch = useDispatch();
    const {changeNameFilter} = bindActionCreators(actionCreators, dispatch)

    // delay input persisting to redux by 1000ms
    useDelayedInput([delayedSearch], () => delayedSearch !== search ? changeNameFilter(delayedSearch) : null, 700);

    const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setDelayedSearch(e.target.value)
    };

    const clear = (): void => {
        setDelayedSearch('')
        changeNameFilter('')
    }

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            changeNameFilter(delayedSearch)
        }
    }

    const publishSearch = (newestSearch?: string) : void => {
        changeNameFilter(newestSearch ?? search)
    }

    return (
        <StrictMode>
            <div className="relative">
                <div className={`${props.className}`}>
                    <div className={`relative md:w-80 max-w-full`}>
                        <input
                            value={delayedSearch}
                            type="text"
                            placeholder="Name suchen"
                            className={`focus:outline-none w-full border focus:border-primary border-neutral-500 py-2 px-3 pr-8 rounded`}
                            onChange={onChange}
                            onClick={(e) => e.currentTarget.select()}
                            onKeyDown={handleKeyDown}
                        />
                        {delayedSearch && (
                            <div onClick={clear} className={'absolute top-3 right-10'}>
                                <XIcon className={'w-4 h-4'}/>
                            </div>
                        )}
                        <SearchIcon className={'absolute top-2 right-2 w-6 h-6'}
                                    onClick={publishSearch}/>
                    </div>
                </div>
            </div>
        </StrictMode>
    )
}
